import { render, staticRenderFns } from "./LeaveApplication.vue?vue&type=template&id=0d48dbda&scoped=true"
import script from "./LeaveApplication.vue?vue&type=script&lang=js"
export * from "./LeaveApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48dbda",
  null
  
)

export default component.exports